/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Ref_H1Inputs */

const en_to_yaml_ref_h1 = /** @type {(inputs: To_Yaml_Ref_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON value`)
};

const ko_to_yaml_ref_h1 = /** @type {(inputs: To_Yaml_Ref_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 값`)
};

const ja_to_yaml_ref_h1 = /** @type {(inputs: To_Yaml_Ref_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON の値`)
};

/**
* | output |
* | --- |
* | "JSON value" |
*
* @param {To_Yaml_Ref_H1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_ref_h1 = /** @type {((inputs?: To_Yaml_Ref_H1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Ref_H1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_ref_h1(inputs)
	if (locale === "ko") return ko_to_yaml_ref_h1(inputs)
	return ja_to_yaml_ref_h1(inputs)
});